import React from 'react'
import FinFactorContainer from 'containers/FinFactor/FinFactorContainer'

const FinfactorBankDetailPage = () => {
    return (
        <FinFactorContainer />
    )
}

export default FinfactorBankDetailPage

